import Container from 'components/container';
import Link from 'next/link';

import { LIBUM_KEYWORDS, LIBUM_URL, SUPPORT_MAILTO } from 'shared/constants/globals';
import { ContentHeadline, ContentPanel } from 'shared/styles/components';
import { CompanyInformationContent } from './company-information.styles';

export default function CompanyInformation() {
  const title = 'Company Information | Libum';
  const description = "Read Libum's company information as well as statement of ownership.";
  const url = `${LIBUM_URL}/company-information`;

  return (
    <Container
      title={title}
      description={description}
      keywords={LIBUM_KEYWORDS}
      url={url}
      socialCard="company-information"
    >
      <div style={{ width: '100%' }}>
        <ContentPanel>
          <ContentHeadline>
            <h1>Company Information</h1>
            <p>Find the legal details for our company.</p>
          </ContentHeadline>
        </ContentPanel>
        <ContentPanel>
          <CompanyInformationContent>
            <h3>Libum, LLC</h3>
            <p>
              1401 Lavaca St
              <br></br>
              PMB 41479
              <br></br>
              Austin, TX 78701
              <br></br>
              United States of America
              <br></br>
              <br></br>
              <b>Email:</b> <Link href={SUPPORT_MAILTO}>support@libum.io</Link>
              <br></br>
              <br></br>
              Libum, LLC is a private limited liability company formed under the laws of the State of Texas, USA.
              <br></br>
              <br></br>
              <b>File Number:</b> 803778468, Department of State, State of Texas.
              <br></br>
              <b>FEIN:</b> 85-3271150
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
            </p>
          </CompanyInformationContent>
        </ContentPanel>
      </div>
    </Container>
  );
}
